import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { AppContext } from "../../../context/AppProvider";
import getLocalizedContent from "../../../lib/getLocalizedMetaData";
import { createCurrentQuarterDetail, weekCount } from "../../../lib/utils";
import { apis } from "../../../services/alm";
import DailyReminder from "../../common/DailyReminder";
import FullScreenProgramCard from "../../common/FullScreenProgramCard/FullScreenProgramCard";
import PageLoader from "../../common/loader/PageLoader";
import MeetingCalendar from "../../common/MeetingCalendar";
import Podcast from "../../common/Podcast";
import withAlmToken from "../../common/withAlmToken";
import UpcommingProgram from "./UpcommingProgram";

const ProgramSection = () => {
  const { state } = useContext(AppContext);
  const [prevQuarterEnrolledProgram, setPrevQuarterEnrolledProgram] =
    useState<any>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (state.user && state?.quarterDeatil?.currentQuarter) {
      learningProgram();
    }
  }, [state?.quarterDeatil?.currentQuarter]);
  useLayoutEffect(() => {
    window.scroll(0, 0);
  }, []);

  const learningProgram = async () => {
    const quarterDetail = createCurrentQuarterDetail(
      state.quarterDeatil.currentQuarter,
      state.quarterDeatil.nextQuarter
    );
    if (quarterDetail.prevQuater) {
      createQuaterData(quarterDetail.prevQuater);
    } else {
      setLoading(false);
    }
  };

  const createQuaterData = async (quarterDetail: any) => {
    const quarter = `${quarterDetail.quarter}-${quarterDetail.year}`;
    const response: any = await apis.getLearningProgram(quarter);
    setLoading(false);
    try {
      if (response) {
        const enrolledData = response?.data.filter((item: any) => {
          return item.relationships.enrollment;
        });
        if (enrolledData.length) {
          const content = getLocalizedContent(
            enrolledData[0].attributes?.localizedMetadata
          );
          const enrollmentId =
            enrolledData[0]?.relationships?.enrollment?.data?.id;
          const progressDetails = response?.included?.find(
            (ele: any) => ele?.id === enrollmentId
          );
          const obj = {
            id: enrolledData[0].id,
            tags: enrolledData[0].attributes?.tags[0],
            bannerUrl: enrolledData[0].attributes?.bannerUrl,
            imageUrl: enrolledData[0].attributes?.imageUrl,
            name: content?.name,
            overview: content?.overview,
            weeks: weekCount(response),
            progress: progressDetails?.attributes?.progressPercent || 0,
            quarterStartDate: quarterDetail.start,
            description: content.description,
            quarter: quarterDetail.quarter,
            relationship: enrolledData[0]?.relationships?.enrollment?.data?.id,
            relationshipInstancesId:
              enrolledData[0]?.relationships?.instances?.data[0]?.id,
            fullCardIncluded: response?.included,
            currentQuarter: state.quarterDeatil.currentQuarter?.quarter,
          };
          setPrevQuarterEnrolledProgram(obj);
        }
      }
    } catch (error: any) {
      console.log("Home page-------", error);
    }
  };
  return (
    <>
      {loading ? (
        <PageLoader />
      ) : (
        <>
          {/* Next Live Meeting */}
          <div className="w-[100%] mx-auto xl:px-32 lg:px-8 md:px-8 px-5 py-6 lg:mb-6">
            <div className="lg:flex lg:items-center lg:justify-between">
              {state.user?.userId && <MeetingCalendar />}
               
            </div>
          </div>
          {prevQuarterEnrolledProgram?.id && (
            <FullScreenProgramCard cardInfo={prevQuarterEnrolledProgram} />
          )}
          <UpcommingProgram
            isPrevQuarterEnrolledProgram={
              prevQuarterEnrolledProgram?.id ? true : false
            }
          />
          {/* Post Cast  */}
          {<Podcast />}
          {/* Daily reminders */}
          {state.user && <DailyReminder />}
        </>
      )}
    </>
  );
};

export default withAlmToken(ProgramSection);
